<nz-form-item>
  <nz-form-label translate>payment.beneficiaryAccountNumber.label</nz-form-label>
  <nz-form-control
    [nzExtra]="beneficiaryAccountNumberControl.valid ? institution?.name : ''"
    [nzValidateStatus]="'validating'"
    [nzHasFeedback]="institutionValidating"
  >
    <app-account-number-input
      nzSize="large"
      [autocompleted]="!!selectedBeneficiary"
      [minlength]="beneficiaryAccountNumberMinLength"
      [maxlength]="beneficiaryAccountNumberMaxLength"
      (validating)="onInstitutionValidating($event)"
      (institution)="onInstitution($event)"
      [placeholder]="'payment.beneficiaryAccountNumber.placeholder' | translate: locale.language"
      (userMustProvideInstitution)="onUserMustProvideInstitution($event)"
      [formControl]="beneficiaryAccountNumberControl"
    ></app-account-number-input>
  </nz-form-control>
</nz-form-item>
